import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";
import { API_NAMES, initApi } from '@usas/ui-web/utils/HttpApiHelper';

const postPaymentRefundData = (receiptNumber, itemsToRefund, state, setState) => {
  if (receiptNumber && itemsToRefund.length > 0) {
    const api = initApi(API_NAMES.PAYMENTSADMIN, state, setState);
    const receiptNumberForUrl = encodeURIComponent(receiptNumber);
    const url = `/Payments/Refund/Receipt/${receiptNumberForUrl}`;

    return api?.executeObject ? api.executeObject(url, 'POST', itemsToRefund) : null;
  }
};

const getPaymentRefundData = (receiptNumber, state, setState) => {
  if (receiptNumber) {
    const newState = {
      ...state,
      receiptNumber
    };

    const api = initApi(API_NAMES.PAYMENTSADMIN, newState, setState);
    const receiptNumberForUrl = encodeURIComponent(receiptNumber);
    const url = `/Payments/Refund/Receipt/${receiptNumberForUrl}`;

    return api?.executeObject ? api.executeObject(url, 'GET') : null;
  }
};

const INITIAL_REFUND_TOOL_STATE = {
  ...BASIC_INITIAL_STATE,
  receiptNumber: ''
};

const RefundToolData = {
  INITIAL_REFUND_TOOL_STATE,
  postPaymentRefundData,
  getPaymentRefundData
};

export default RefundToolData;